import { Dossier } from './dossier';
import { DossierStatus } from './dossier.status';

/**
 * The dossier details
 */
export class DossierDetails {

    /**
     * The dossier
     */
    dossier: Dossier;
    /**
     * The flag for has status history
     */
    hasStatusHistory: boolean;
    /**
     * The dossier status history list
     */
    statusHistory: DossierStatus[];
}